import React from 'react';
import './EmptyState.css';

interface EmptyStateProps {
  /** Lucide icon element, rendered large and muted. */
  icon: React.ReactNode;
  /** What this page is for, e.g. "No products yet". */
  title: string;
  /** One or two sentences teaching what belongs here and why. */
  description: string;
  /** Label of the primary call-to-action button. */
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Rich empty state for list pages: instead of "No data found", teach the user
 * what the page does and give them the first action. Part of the
 * zero-pre-training UX (Tier 1).
 */
const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, actionLabel, onAction }) => (
  <div className="ims-empty-state">
    <div className="ims-empty-state-icon">{icon}</div>
    <h3 className="ims-empty-state-title">{title}</h3>
    <p className="ims-empty-state-text">{description}</p>
    {actionLabel && onAction && (
      <button className="ims-btn ims-btn-primary" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

export default EmptyState;
